export const servicesList = [
  {
    id: "website-dev",
    key: "website-dev",
    icon: "fas fa-globe",
    titleKey: "service1-title",
    descKey: "service1-desc",
  },
  {
    id: "web-app",
    key: "web-app",
    icon: "fas fa-laptop-code",
    titleKey: "service2-title",
    descKey: "service2-desc",
  },
  {
    id: "mobile-app",
    key: "mobile-app",
    icon: "fas fa-mobile-alt",
    titleKey: "service3-title",
    descKey: "service3-desc",
  },
  {
    id: "it-managed",
    key: "it-managed",
    icon: "fas fa-server",
    titleKey: "service4-title",
    descKey: "service4-desc",
  },
];
